module.exports = __webpack_public_path__ + "00fbc451ede9c85a25d366a6c232d306.json";


//////////////////
// WEBPACK FOOTER
// ./src/portal/i18n/de.json
// module id = 1080
// module chunks = 0